/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * How the skill affected the task.
 */
export const SkillFeedbackPayloadOutcome = {
  Helped: "helped",
  PartiallyHelped: "partially_helped",
  DidNotHelp: "did_not_help",
  Misleading: "misleading",
  Harmful: "harmful",
} as const;
/**
 * How the skill affected the task.
 */
export type SkillFeedbackPayloadOutcome = ClosedEnum<
  typeof SkillFeedbackPayloadOutcome
>;

/**
 * Contract version.
 */
export const SchemaVersion = {
  HookSkillFeedbackV1: "hook.skill-feedback.v1",
} as const;
/**
 * Contract version.
 */
export type SchemaVersion = ClosedEnum<typeof SchemaVersion>;

/**
 * Agent-volunteered feedback about a distributed skill.
 */
export type SkillFeedbackPayload = {
  /**
   * Optional concise context about the outcome.
   */
  note?: string | undefined;
  /**
   * How the skill affected the task.
   */
  outcome: SkillFeedbackPayloadOutcome;
  /**
   * Contract version.
   */
  schemaVersion: SchemaVersion;
  /**
   * Canonical name of the skill that was used.
   */
  skill: string;
};

/** @internal */
export const SkillFeedbackPayloadOutcome$outboundSchema: z.ZodMiniEnum<
  typeof SkillFeedbackPayloadOutcome
> = z.enum(SkillFeedbackPayloadOutcome);

/** @internal */
export const SchemaVersion$outboundSchema: z.ZodMiniEnum<typeof SchemaVersion> =
  z.enum(SchemaVersion);

/** @internal */
export type SkillFeedbackPayload$Outbound = {
  note?: string | undefined;
  outcome: string;
  schema_version: string;
  skill: string;
};

/** @internal */
export const SkillFeedbackPayload$outboundSchema: z.ZodMiniType<
  SkillFeedbackPayload$Outbound,
  SkillFeedbackPayload
> = z.pipe(
  z.object({
    note: z.optional(z.string()),
    outcome: SkillFeedbackPayloadOutcome$outboundSchema,
    schemaVersion: SchemaVersion$outboundSchema,
    skill: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      schemaVersion: "schema_version",
    });
  }),
);

export function skillFeedbackPayloadToJSON(
  skillFeedbackPayload: SkillFeedbackPayload,
): string {
  return JSON.stringify(
    SkillFeedbackPayload$outboundSchema.parse(skillFeedbackPayload),
  );
}
